import React, { useContext } from "react";

const ViewboxContext = React.createContext<null | HTMLDivElement>(null);

export function useViewBox(): null | HTMLDivElement {
	return useContext(ViewboxContext);
}

export const ViewboxContextProvider = ViewboxContext.Provider;
